export default "/images/5f5b5469ff2b5f7ec183544ddb7c5bbd.avif";